import React from 'react';
import './PickButton.less';

interface IPickButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  text: string;
  buttonRef: React.MutableRefObject<HTMLButtonElement | null>;
}

export function PickButton({ text, buttonRef, onClick }: IPickButtonProps) {
  return (
    <button className="dpc-pick-button" onClick={onClick} ref={buttonRef}>
      {text} <i className="dpc-pick-button__icon" />
    </button>
  );
}
